/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SharedserviceMelcoModelsAddColorCollection,
    SharedserviceMelcoModelsAddColorCollectionFromJSON,
    SharedserviceMelcoModelsAddColorCollectionToJSON,
    SharedserviceMelcoModelsColorCollection,
    SharedserviceMelcoModelsColorCollectionFromJSON,
    SharedserviceMelcoModelsColorCollectionToJSON,
    SharedserviceMelcoModelsColorCollectionReferences,
    SharedserviceMelcoModelsColorCollectionReferencesFromJSON,
    SharedserviceMelcoModelsColorCollectionReferencesToJSON,
    SharedserviceMelcoModelsError,
    SharedserviceMelcoModelsErrorFromJSON,
    SharedserviceMelcoModelsErrorToJSON,
    SharedserviceMelcoModelsGenericList1MelcoModelsColorCollection,
    SharedserviceMelcoModelsGenericList1MelcoModelsColorCollectionFromJSON,
    SharedserviceMelcoModelsGenericList1MelcoModelsColorCollectionToJSON,
    SharedserviceMelcoModelsUpdateColorCollection,
    SharedserviceMelcoModelsUpdateColorCollectionFromJSON,
    SharedserviceMelcoModelsUpdateColorCollectionToJSON,
} from '../models';

export interface ColorCollectionsDraftApiColorCollectionsReferencesRequest {
    id: string;
}

export interface ColorCollectionsDraftApiUserColorCollectionPublishRequest {
    id: string;
}

export interface ColorCollectionsDraftApiUserColorCollectionUpdateDraftRequest {
    id: string;
    sharedserviceMelcoModelsUpdateColorCollection?: SharedserviceMelcoModelsUpdateColorCollection;
}

export interface ColorCollectionsDraftApiUserColorCollectionsAddDraftRequest {
    sharedserviceMelcoModelsAddColorCollection?: SharedserviceMelcoModelsAddColorCollection;
}

export interface ColorCollectionsDraftApiUserColorCollectionsDeleteRequest {
    id: string;
    force?: boolean;
}

export interface ColorCollectionsDraftApiUserColorCollectionsDownloadRequest {
    id: string;
    publishState?: string;
    productCode?: string;
}

export interface ColorCollectionsDraftApiUserColorCollectionsDuplicateDraftRequest {
    id: string;
}

export interface ColorCollectionsDraftApiUserColorCollectionsGetDefRequest {
    id: string;
    publishState?: string;
}

export interface ColorCollectionsDraftApiUserColorCollectionsGetListRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    searchText?: string;
    service?: string;
    publishState?: string;
}

export interface ColorCollectionsDraftApiUserColorCollectionsRevertRequest {
    id: string;
}

/**
 * 
 */
export class ColorCollectionsDraftApi extends runtime.BaseAPI {

    /**
     */
    async colorCollectionsReferencesRaw(requestParameters: ColorCollectionsDraftApiColorCollectionsReferencesRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsColorCollectionReferences>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling colorCollectionsReferences.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/colors/collections/{Id}/references`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsColorCollectionReferencesFromJSON(jsonValue));
    }

    /**
     */
    async colorCollectionsReferences(requestParameters: ColorCollectionsDraftApiColorCollectionsReferencesRequest): Promise<SharedserviceMelcoModelsColorCollectionReferences> {
        const response = await this.colorCollectionsReferencesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userColorCollectionPublishRaw(requestParameters: ColorCollectionsDraftApiUserColorCollectionPublishRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsColorCollection>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userColorCollectionPublish.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/colors/collections/{Id}/publish`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsColorCollectionFromJSON(jsonValue));
    }

    /**
     */
    async userColorCollectionPublish(requestParameters: ColorCollectionsDraftApiUserColorCollectionPublishRequest): Promise<SharedserviceMelcoModelsColorCollection> {
        const response = await this.userColorCollectionPublishRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userColorCollectionUpdateDraftRaw(requestParameters: ColorCollectionsDraftApiUserColorCollectionUpdateDraftRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsColorCollection>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userColorCollectionUpdateDraft.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/colors/collections/{Id}/draft`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SharedserviceMelcoModelsUpdateColorCollectionToJSON(requestParameters.sharedserviceMelcoModelsUpdateColorCollection),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsColorCollectionFromJSON(jsonValue));
    }

    /**
     */
    async userColorCollectionUpdateDraft(requestParameters: ColorCollectionsDraftApiUserColorCollectionUpdateDraftRequest): Promise<SharedserviceMelcoModelsColorCollection> {
        const response = await this.userColorCollectionUpdateDraftRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userColorCollectionsAddDraftRaw(requestParameters: ColorCollectionsDraftApiUserColorCollectionsAddDraftRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsColorCollection>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/colors/collections/draft`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SharedserviceMelcoModelsAddColorCollectionToJSON(requestParameters.sharedserviceMelcoModelsAddColorCollection),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsColorCollectionFromJSON(jsonValue));
    }

    /**
     */
    async userColorCollectionsAddDraft(requestParameters: ColorCollectionsDraftApiUserColorCollectionsAddDraftRequest): Promise<SharedserviceMelcoModelsColorCollection> {
        const response = await this.userColorCollectionsAddDraftRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userColorCollectionsDeleteRaw(requestParameters: ColorCollectionsDraftApiUserColorCollectionsDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userColorCollectionsDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.force !== undefined) {
            queryParameters['Force'] = requestParameters.force;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/colors/collections/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userColorCollectionsDelete(requestParameters: ColorCollectionsDraftApiUserColorCollectionsDeleteRequest): Promise<void> {
        await this.userColorCollectionsDeleteRaw(requestParameters);
    }

    /**
     */
    async userColorCollectionsDownloadRaw(requestParameters: ColorCollectionsDraftApiUserColorCollectionsDownloadRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userColorCollectionsDownload.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        if (requestParameters.productCode !== undefined) {
            queryParameters['product_code'] = requestParameters.productCode;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/colors/collections/{Id}/download`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async userColorCollectionsDownload(requestParameters: ColorCollectionsDraftApiUserColorCollectionsDownloadRequest): Promise<Blob> {
        const response = await this.userColorCollectionsDownloadRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userColorCollectionsDuplicateDraftRaw(requestParameters: ColorCollectionsDraftApiUserColorCollectionsDuplicateDraftRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsColorCollection>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userColorCollectionsDuplicateDraft.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/colors/collections/{Id}/duplicate/draft`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsColorCollectionFromJSON(jsonValue));
    }

    /**
     */
    async userColorCollectionsDuplicateDraft(requestParameters: ColorCollectionsDraftApiUserColorCollectionsDuplicateDraftRequest): Promise<SharedserviceMelcoModelsColorCollection> {
        const response = await this.userColorCollectionsDuplicateDraftRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userColorCollectionsGetDefRaw(requestParameters: ColorCollectionsDraftApiUserColorCollectionsGetDefRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsColorCollection>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userColorCollectionsGetDef.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/colors/collections/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsColorCollectionFromJSON(jsonValue));
    }

    /**
     */
    async userColorCollectionsGetDef(requestParameters: ColorCollectionsDraftApiUserColorCollectionsGetDefRequest): Promise<SharedserviceMelcoModelsColorCollection> {
        const response = await this.userColorCollectionsGetDefRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userColorCollectionsGetListRaw(requestParameters: ColorCollectionsDraftApiUserColorCollectionsGetListRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsGenericList1MelcoModelsColorCollection>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.service !== undefined) {
            queryParameters['service'] = requestParameters.service;
        }

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/colors/collections`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsGenericList1MelcoModelsColorCollectionFromJSON(jsonValue));
    }

    /**
     */
    async userColorCollectionsGetList(requestParameters: ColorCollectionsDraftApiUserColorCollectionsGetListRequest): Promise<SharedserviceMelcoModelsGenericList1MelcoModelsColorCollection> {
        const response = await this.userColorCollectionsGetListRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userColorCollectionsRevertRaw(requestParameters: ColorCollectionsDraftApiUserColorCollectionsRevertRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userColorCollectionsRevert.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/colors/collections/{Id}/revert`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userColorCollectionsRevert(requestParameters: ColorCollectionsDraftApiUserColorCollectionsRevertRequest): Promise<void> {
        await this.userColorCollectionsRevertRaw(requestParameters);
    }

}
